<template>
  <div class="strong-container">
    <div class="banner-container">
      <img src="../../../assets/images/strong/banner.jpg" />
    </div>
    <p class="section-title-line">
      <span>新希望地产人才培养与发展</span>
    </p>
    <div class="section-container">
      <div class="wow animate__slideInUp" data-wow-duration="500ms">
        <div
          class="header-box header-box1"
        >
          <p>强将计划</p>
        </div>
        <el-row class="bottom-box">
          <el-col :span="14">
            <div class="title-item">
              <p>培养目的</p>
              <div class="img-box">
                <img
                  src="../../../assets/images/strong/1.png"
                  alt=""
                />
                <img
                  src="../../../assets/images/strong/2.png"
                  alt=""
                />
                <img
                  src="../../../assets/images/strong/3.png"
                  alt=""
                />
                <img
                  src="../../../assets/images/strong/2.png"
                  alt=""
                />
                <img
                  src="../../../assets/images/strong/4.png"
                  alt=""
                />
                <img
                  src="../../../assets/images/strong/2.png"
                  alt=""
                />
                <img
                  src="../../../assets/images/strong/5.png"
                  alt=""
                />
              </div>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="title-item" style="border-right: none">
              <p>培养方式</p>
              <div class="img-box">
                <div style="margin-bottom: 18px">
                  <p style="background: #3a834e">课程培训</p>
                  <p style="background: #3a834e">高管学习</p>
                  <p style="background: #3a834e">考核评估</p>
                </div>
                <div>
                  <p style="background: #3a834e">行动学习</p>
                  <p style="background: #3a834e">试岗锻炼</p>
                  <p style="background: #3a834e">项目考察</p>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="mt50 wow animate__slideInUp" data-wow-duration="500ms">
        <div
          class="header-box header-box2"
        >
          <p>校招生</p>
        </div>
        <el-row class="bottom-box">
          <el-col :span="8">
            <div class="school-item">
              <p>新领袖</p>
              <p>目标：5-6年项目领导者（项目负责人、职能总监）</p>
              <p>路径：1-2年成为业务部门业务骨干，4年培养成为M3级管理干部</p>
              <p>画像：985硕士乃至博士、工程类专业、学生会主席、领导者潜质</p>
            </div>
          </el-col>
          <el-col :span="8"
            ><div class="school-item">
              <p>新未来</p>
              <p>目标：成为工程、投资、成本、资金、财务等专业骨干或管理干部</p>
              <p>路径：经过2年的培养，可成为专业领域骨干（P2）</p>
              <p>画像：985/211硕士或优秀本科生，成绩优异</p>
            </div></el-col
          >
          <el-col :span="8"
            ><div class="school-item school-item-right">
              <p>新梦想</p>
              <p>目标：培养未来的营销精英及营销管理人才</p>
              <p>路径：经过1-2年的培养，成为营销策划、销售等业务骨干</p>
              <p>画像：本科、营销气质、综合素质佳</p>
            </div></el-col
          >
        </el-row>
      </div>

      <div class="mt50">
        <pull-refresh-list></pull-refresh-list>
      </div>

      <div class="mt50 wow animate__slideInUp" data-wow-duration="500ms">
        <el-row>
          <el-col :span="16" class="leave-word-left">
            <img
              style="height: 100%"
              src="../../../assets/images/strong/bg3.jpeg"
              alt=""
            />
          </el-col>
          <el-col :span="8" class="leave-word-right">
            <p>
              “登高，是一种追求与眺望，我们徒步体验卓越前行；黑暗，是一种忍耐与冥想，我们心有明灯穿越洞穴；速降，是一种挑战与冒险，我们义无反顾超越自我；学习，是一种充电与蓄能，我们心怀感恩挑灯夜战；总裁讲堂，457的希望，强将学员，将奋斗者的使命扛在肩上。聚是一团火，散是满天星，同学同窗，朋友师长，奔赴战场，强将担当，有你有我有希望，再见我们不再一样！”
            </p>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import PullRefreshList from "@/components/pullRefreshList";

export default {
  name: "StrongPage",
  components: {
    PullRefreshList,
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.strong-container {
  .header-box {
    height: 106px;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    font-size: 28px;
    color: #fff;
    line-height: 106px;
    padding-left: 40px;
  }

  .header-box1 {
    background-image: url('../../../assets/images/strong/bg1.png')
  }

  .header-box2 {
    background-image: url('../../../assets/images/strong/bg2.png')
  }

  .title-item {
    margin: 30px 0;
    padding: 10px 40px;
    border-right: 1px dashed #008048;

    &.title-item-right {
      border-right: none;
    }

    > p {
      font-size: 22px;
      color: #008048;
      text-align: center;
      margin-bottom: 20px;
    }
  }

  .img-box {
    overflow: hidden;
    > img {
      float: left;
      width: 15%;
      margin: 0 10px;
    }

    > img:first-child {
      margin-left: 0;
    }

    > img:nth-child(2n + 2) {
      width: 5% !important;
      margin-top: 30px;
    }

    > div {
      width: 100%;
      text-align: center;
      margin-bottom: 18px;

      &:last-child {
        margin-bottom: 0;
      }

      > p {
        border-radius: 1px;
        width: 85px;
        height: 30px;
        line-height: 30px;
        background: #3a834e;
        font-size: 13px;
        color: #fff;
        display: inline-block;
        margin: 0 7px;
      }
    }
  }

  .bottom-box {
    border: 1px solid #3a834e;
    border-top: none;
  }

  .school-item {
    margin: 30px 0;
    padding: 10px 40px;
    border-right: 1px dashed #008048;
    height: 214px;

    &.school-item-right {
      border-right: none;
    }

    > p {
      font-size: 13px;
      line-height: 23px;
      color: #565c61;
    }

    > p:first-child {
      border-radius: 1px;
      width: 85px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background: #008048;
      font-size: 13px;
      color: #fff;
      text-align: center;
      margin-bottom: 30px;
    }
  }

  .mt50 {
    margin-top: 50px;
  }

  .leave-word {
    &-left {
      height: 463px;
      background-color: #f2f2f2;
    }

    &-right {
      height: 463px;
      background-color: #f2f2f2;
      padding: 50px;
      box-sizing: border-box;
      background: #f2f2f2;
      font-size: 14px;
      color: #565c61;
      line-height: 30px;
      text-align: justify;

      > p {
        text-indent: 30px;
        width: 210px;
        margin-left: 60px;
      }
    }
  }
}
</style>
